import { User } from "@sentry/react";

const filterUsersByTeamId = (users?: User[], teamId?: string) => {
  if (!teamId) return [];
  if (!users) return [];
  return users?.filter((user) => user["teamId"] === teamId) || [];
};

export default filterUsersByTeamId;
